import controller from './kform-builder-option-tags.controller';
import template from './kform-builder-option-tags.html';

const kformBuilderOptionTagsDirective = /* @ngInject */ () => ({
	restrict: 'E',
	replace: true,
	template,
	controller,
});

export default kformBuilderOptionTagsDirective;
